import React, { useEffect, useState } from "react";
import ManagerCommuteStatics from "./ManagerCommuteStatics";


function ManagerCommuteStaticsCompany() {  
  return (
    <ManagerCommuteStatics showCompanyList={true}/>
  );  
}

export default ManagerCommuteStaticsCompany;